export const calcColumnLine = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/calcColumnLine', params);
        },
    };
};
